import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import HouseFeatures from "@/components/builder/HouseFeatures.vue";
  import { formatPrice } from "@/helpers/transformation/price";
  import { POSITION, useToast } from "vue-toastification";
  import { BuilderInterface } from "@/types/BuilderInterface";
  import store from "@/store";
  import { calculateBuildPriceOrPackagePriceTotal } from "@/helpers/builder/calculateBuildPriceOrPackagePriceTotal";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseDetailsForLandPackage',
  props: {
    siteCosts: {},
    houseInfo: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const toast = useToast();
  const builder = ref<BuilderInterface>();
  const selectedFacadeId = computed(
    () => store.getters["facade/selectedFacadeId"]
  );

  const buildPriceWithFacade = computed(() => {
    const facade = props.houseInfo?.facades.find(
      (facade) => facade._id === selectedFacadeId.value
    );
    const basePrice = Number(props.houseInfo?.basePrice);
    const facadePrice = Number(facade?.price || 0);

    return calculateBuildPriceOrPackagePriceTotal(
      basePrice,
      facadePrice,
      props?.siteCosts
    );
  });

  const getBuilderById = () => {
    if (props.houseInfo) {
      store
        .dispatch("builder/getBuilderById", props.houseInfo.builderId)
        .then((res) => {
          builder.value = res.data;
        })
        .catch(() => {
          toast.error("Error fetching builder by id", {
            position: POSITION.TOP_LEFT,
          });
        });
    }
  };

  onMounted(() => {
    getBuilderById();
  });

const __returned__ = { props, toast, builder, selectedFacadeId, buildPriceWithFacade, getBuilderById, computed, onMounted, ref, get HouseDesignInterface() { return HouseDesignInterface }, HouseFeatures, get formatPrice() { return formatPrice }, get POSITION() { return POSITION }, get useToast() { return useToast }, get BuilderInterface() { return BuilderInterface }, get store() { return store }, get calculateBuildPriceOrPackagePriceTotal() { return calculateBuildPriceOrPackagePriceTotal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})